// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCIt4mJdIr5CxTlmMZrzxunRDOSMiqWsBA",
  authDomain: "sthapnadh.firebaseapp.com",
  projectId: "sthapnadh",
  storageBucket: "sthapnadh.appspot.com",
  messagingSenderId: "975607798913",
  appId: "1:975607798913:web:5d401932d5731d9a030180",
  measurementId: "G-CE75QXEV04"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export default app;
export { auth };

export const signInWithGoogle = () => {
  signInWithPopup(auth, provider).then((result) => {
    console.log(result);
  })
  .catch((error) => {
    console.log(error);
  });
};

